export interface BundleServerOptions {
  disableCache: boolean;
  port?: number | number[];
}
